import * as React from 'react';
import { Link } from 'react-router';

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'mate... Remove this comment to see the full error message
import MuiLeftNav from 'material-ui/Drawer';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'mate... Remove this comment to see the full error message
import MenuItem from 'material-ui/MenuItem';

import { HelpIcon } from '@coursera/cds-icons';

import CourseraLogo from 'bundles/page/components/CourseraLogo';

import 'css!./__styles__/LeftNav';

export type MenuItemProps = {
  external?: boolean;
  name: string;
  route: string;
};

type Props = {
  menuItems?: Array<MenuItemProps>;
  profile: {
    name: string;
    emailAddress: string;
  };
};

const LeftNav = ({ menuItems = [], profile = { name: '', emailAddress: '' } }: Props) => {
  return (
    <div className="rc-LeftNav">
      <MuiLeftNav
        containerStyle={{
          display: 'flex',
          flexDirection: 'column',
          width: '200px',
        }}
      >
        <div className="user">
          <div className="logo">
            <a href="/internal">
              <CourseraLogo hexColorCode="#eceff1" />
            </a>
          </div>
          <div className="name">
            <span>{profile.name}</span>
            <br />
            <small>{profile.emailAddress}</small>
          </div>
        </div>
        <div className="nav-items">
          {menuItems.map((menuItem) => {
            return menuItem.external ? (
              <a href={menuItem.route} key={menuItem.name}>
                <MenuItem key={menuItem.name}>{menuItem.name}</MenuItem>
              </a>
            ) : (
              <Link to={menuItem.route} key={menuItem.name}>
                <MenuItem key={menuItem.name}>{menuItem.name}</MenuItem>
              </Link>
            );
          })}
        </div>
        <div className="tool-help-link">
          <a href="http://go.dkandu.me/internal-tool-troubleshooting" target="_blank" rel="noopener noreferrer">
            <HelpIcon />
            <div>Having trouble with a tool?</div>
          </a>
        </div>
      </MuiLeftNav>
    </div>
  );
};

export default LeftNav;
